// extracted by mini-css-extract-plugin
export var btn = "invent-module--btn--d3927";
export var col = "invent-module--col--e3829";
export var h2 = "invent-module--h2--3c3a8";
export var invent = "invent-module--invent--de078";
export var item = "invent-module--item--212b6";
export var speaker = "invent-module--speaker--0a653";
export var theme = "invent-module--theme--ea960";